var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAstronaut = _ref => {
  let {
    className,
    height = 86,
    titleId,
    title,
    ref,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 86",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F18686",
    d: "M68.765 45.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l1.654 1.652 11.807 11.825 1.576 1.576a5 5 0 0 1 0 7.07l-7.198 7.198-21.931-21.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M65.512 75.211l5.422-5.42a3.068 3.068 0 1 0-4.338-4.338l-5.42 5.422a3.068 3.068 0 0 1-4.336-.116 3.068 3.068 0 0 1-.002-4.216l9.758-9.758a3.07 3.07 0 0 1-4.336-4.349l6.505-6.499a6.133 6.133 0 0 1 8.675 0l13.01 13.01a6.133 6.133 0 0 1 0 8.675l-6.505 6.506a3.068 3.068 0 1 1-4.338-4.338l-9.758 9.758a3.065 3.065 0 1 1-4.336-4.336z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M66.596 56.78l5.422-5.421"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M89.907 38.045a8.434 8.434 0 1 1-.001 16.868 8.434 8.434 0 0 1 0-16.868z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M85.029 64.37l-5.422 5.422M68.765 45.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l.002.002 1.652 1.65M90.45 67.622l7.59-7.589a4.598 4.598 0 0 0 .001-6.503l-.002-.002-1.652-1.652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M78.163 55.335l2.891 2.891a1.023 1.023 0 0 1 0 1.446l-2.89 2.89a1.023 1.023 0 0 1-1.446 0l-2.891-2.89a1.023 1.023 0 0 1 0-1.446l2.89-2.89a1.02 1.02 0 0 1 1.446 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M95.296 52.962a15.052 15.052 0 0 0-3.762-8.109 15.063 15.063 0 0 0-8.108-3.77M73.921 75.477l1.163 1.337c6.539 7.505 17.922 8.288 25.427 1.752.501-.437.98-.901 1.43-1.392"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0D8",
    d: "M42 23c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM117 20c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM150 67c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 59.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 47.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 26.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 73.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 32.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 39.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 54.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 57.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))))));
};
export const Icon = _ref2 => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 86,
    titleId,
    title,
    ref,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 86",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F18686",
    d: "M68.765 45.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l1.654 1.652 11.807 11.825 1.576 1.576a5 5 0 0 1 0 7.07l-7.198 7.198-21.931-21.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M65.512 75.211l5.422-5.42a3.068 3.068 0 1 0-4.338-4.338l-5.42 5.422a3.068 3.068 0 0 1-4.336-.116 3.068 3.068 0 0 1-.002-4.216l9.758-9.758a3.07 3.07 0 0 1-4.336-4.349l6.505-6.499a6.133 6.133 0 0 1 8.675 0l13.01 13.01a6.133 6.133 0 0 1 0 8.675l-6.505 6.506a3.068 3.068 0 1 1-4.338-4.338l-9.758 9.758a3.065 3.065 0 1 1-4.336-4.336z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M66.596 56.78l5.422-5.421"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M89.907 38.045a8.434 8.434 0 1 1-.001 16.868 8.434 8.434 0 0 1 0-16.868z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M85.029 64.37l-5.422 5.422M68.765 45.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l.002.002 1.652 1.65M90.45 67.622l7.59-7.589a4.598 4.598 0 0 0 .001-6.503l-.002-.002-1.652-1.652"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M78.163 55.335l2.891 2.891a1.023 1.023 0 0 1 0 1.446l-2.89 2.89a1.023 1.023 0 0 1-1.446 0l-2.891-2.89a1.023 1.023 0 0 1 0-1.446l2.89-2.89a1.02 1.02 0 0 1 1.446 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M95.296 52.962a15.052 15.052 0 0 0-3.762-8.109 15.063 15.063 0 0 0-8.108-3.77M73.921 75.477l1.163 1.337c6.539 7.505 17.922 8.288 25.427 1.752.501-.437.98-.901 1.43-1.392"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0D8",
    d: "M42 23c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM117 20c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM150 67c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 59.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 47.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 26.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 73.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 32.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 39.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 54.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 57.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))))));
};
export default SvgAstronaut;
export const raw = __webpack_public_path__ + "static/media/astronaut.01fd737e278b9776d0f96aedff38948f.svg";